<button class="btn btn-circle btn-success" matTooltip="הורד דו''ח"  *authGuardDirective="'commitments,reports'"
(click)="getContactShortInformation()">
<i class="fa fa-download"></i></button>